export default __webpack_public_path__ + "static/media/Seccion_promos_pasada_18_Septiembre.726aa435.webp";